/** @format */
//TODO: Disable suppres and fix the error
/* eslint-disable react/no-string-refs */

import React from 'react';
import PropTypes from 'prop-types';

import PerfectScrollbar from 'perfect-scrollbar';
import {NavLink} from 'react-router-dom';
import cx from 'classnames';

import withStyles from '@material-ui/core/styles/withStyles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Hidden from '@material-ui/core/Hidden';
import Collapse from '@material-ui/core/Collapse';
import Icon from '@material-ui/core/Icon';
import {Auth} from '../../modules/auth/Auth';
import i18n from 'core/i18n';
import VersionCheck from '../../core/VersionCheck';
import OplSidebarStyle from '../../assets/themes/OPL/jss/Sidebar/OplSidebarStyle';
import {ReactComponent as ArrowDown} from '../../assets/themes/OPL/img/icons/ArrowDown.svg';
import {ReactComponent as ArrowUp} from '../../assets/themes/OPL/img/icons/ArrowUp.svg';
import Button from '../CustomButtons/Button';
import ViewList from '@material-ui/icons/ViewList';
import MoreVert from '@material-ui/icons/MoreVert';
import {ReactComponent as Download} from '../../assets/themes/OPL/img/icons/Download.svg';
import COLORS from '../../assets/themes/OPL/colors';
import I18n from "../Translate/I18n";

let ps;

class SidebarWrapper extends React.Component {
    componentDidMount() {
        if (navigator.platform.indexOf('Win') > -1) {
            ps = new PerfectScrollbar(this.refs.sidebarWrapper, {
                suppressScrollX: true,
                suppressScrollY: false,
            });
        }
    }

    componentWillUnmount() {
        if (navigator.platform.indexOf('Win') > -1) {
            ps.destroy();
        }
    }

    render() {
        const {className, user, headerLinks, links} = this.props;
        return (
            <div className={className} ref="sidebarWrapper">
                {user}
                {headerLinks}
                {links}
            </div>
        );
    }
}

class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openAvatar: false,
            miniActive: true,
            ...this.getCollapseStates(props.routes),
        };
        this.versionCheck = new VersionCheck();
    }

    getCollapseStates = (routes) => {
        let initialState = {};
        routes.map((prop, key) => {
            if (prop.collapse) {
                initialState = {
                    [prop.state]: this.getCollapseInitialState(prop.views),
                    ...this.getCollapseStates(prop.views),
                    ...initialState,
                };
            }
            return null;
        });
        return initialState;
    };

    getCollapseInitialState(routes) {
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
                return true;
            } else if (window.location.href.indexOf(routes[i].path) !== -1) {
                return true;
            }
        }
        return false;
    }

    activeRoute = (routeName) => {
        return this.props.location.pathname.indexOf(routeName) > -1 ? 'active' : '';
    };

    openCollapse(collapse) {
        const st = {};
        st[collapse] = !this.state[collapse];
        this.setState(st);
    }

    createLinks = (routes) => {
        const {classes, color, rtlActive} = this.props;
        return routes.map((prop, key) => {
            if (prop.redirect) {
                return null;
            }
            if (prop.display === false) {
                return null;
            }
            if (prop.collapse) {
                const st = {};
                st[prop['state']] = !this.state[prop.state];
                const navLinkClasses =
                    classes.itemLink +
                    ' ' +
                    cx({
                        [' ' + classes.collapseActive]: this.getCollapseInitialState(prop.views),
                    });
                const itemText =
                    classes.itemText +
                    ' ' +
                    cx({
                        [classes.itemTextMini]: this.props.miniActive && this.state.miniActive,
                        [classes.itemTextMiniRTL]: rtlActive && this.props.miniActive && this.state.miniActive,
                        [classes.itemTextRTL]: rtlActive,
                    });
                const collapseItemText =
                    classes.collapseItemText +
                    ' ' +
                    cx({
                        [classes.collapseItemTextMini]: this.props.miniActive && this.state.miniActive,
                        [classes.collapseItemTextMiniRTL]: rtlActive && this.props.miniActive && this.state.miniActive,
                        [classes.collapseItemTextRTL]: rtlActive,
                    });
                const itemIcon =
                    classes.itemIcon +
                    ' ' +
                    cx({
                        [classes.itemIconRTL]: rtlActive,
                    });
                const caret =
                    classes.caret +
                    ' ' +
                    cx({
                        [classes.caretRTL]: rtlActive,
                    });
                const collapseItemMini =
                    classes.collapseItemMini +
                    ' ' +
                    cx({
                        [classes.collapseItemMiniRTL]: rtlActive,
                    });
                const itemIconWrapper = classes.itemIconWrapper;

                return (
                    <ListItem
                        key={key}
                        className={cx({[classes.item]: prop.icon !== undefined}, {[classes.collapseItem]: prop.icon === undefined})}
                    >
                        <NavLink
                            to={'#'}
                            className={navLinkClasses}
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState(st);
                            }}
                        >
                            {prop.icon !== undefined ? (
                                typeof prop.icon === 'string' ? (
                                    <Icon className={itemIcon}>{prop.icon}</Icon>
                                ) : (
                                    <div className={itemIconWrapper}>
                                        <prop.icon className={itemIcon}/>
                                    </div>
                                )
                            ) : (
                                <span className={collapseItemMini}>{rtlActive ? prop.rtlMini : prop.mini}</span>
                            )}
                            <ListItemText
                                primary={rtlActive ? prop.rtlName : <I18n trans={`general:menu.${prop.name}`}/>}
                                secondary={this.state[prop.state] ?
                                    <ArrowUp className={`${classes.sidebarArrow} ${classes.sidebarArrowActive}`}/> :
                                    <ArrowDown className={classes.sidebarArrow}/>}
                                disableTypography={true}
                                className={cx({[itemText]: prop.icon !== undefined}, {[collapseItemText]: prop.icon === undefined})}
                            />
                        </NavLink>
                        <Collapse in={this.state[prop.state]} unmountOnExit>
                            <List
                                className={classes.list + ' ' + classes.collapseList}>{this.createLinks(prop.views)}</List>
                        </Collapse>
                    </ListItem>
                );
            }
            const innerNavLinkClasses =
                classes.collapseItemLink +
                ' ' +
                cx({
                    [' ' + classes[color]]: this.activeRoute(prop.path),
                });
            const collapseItemMini =
                classes.collapseItemMini +
                ' ' +
                cx({
                    [classes.collapseItemMiniRTL]: rtlActive,
                });
            const navLinkClasses =
                classes.itemLink +
                ' ' +
                cx({
                    [' ' + classes[color]]: this.activeRoute(prop.path),
                });
            const itemText =
                classes.itemText +
                ' ' +
                cx({
                    [classes.itemTextMini]: this.props.miniActive && this.state.miniActive,
                    [classes.itemTextMiniRTL]: rtlActive && this.props.miniActive && this.state.miniActive,
                    [classes.itemTextRTL]: rtlActive,
                });
            const collapseItemText =
                classes.collapseItemText +
                ' ' +
                cx({
                    [classes.collapseItemTextMini]: this.props.miniActive && this.state.miniActive,
                    [classes.collapseItemTextMiniRTL]: rtlActive && this.props.miniActive && this.state.miniActive,
                    [classes.collapseItemTextRTL]: rtlActive,
                });
            const itemIcon =
                classes.itemIcon +
                ' ' +
                cx({
                    [classes.itemIconRTL]: rtlActive,
                });
            const itemIconWrapper = classes.itemIconWrapper;
            return (
                <ListItem key={key}
                          className={cx({[classes.item]: prop.icon !== undefined}, {[classes.collapseItem]: prop.icon === undefined})}>
                    <NavLink
                        to={prop.layout + prop.path}
                        className={cx({[navLinkClasses]: prop.icon !== undefined}, {[innerNavLinkClasses]: prop.icon === undefined})}
                    >
                        {prop.icon !== undefined ? (
                            typeof prop.icon === 'string' ? (
                                <Icon className={itemIcon}>{prop.icon}</Icon>
                            ) : (
                                <div className={itemIconWrapper}>
                                    <prop.icon className={itemIcon}/>
                                </div>
                            )
                        ) : (
                            <span className={collapseItemMini}>{prop.mini}</span>
                        )}
                        <ListItemText
                            primary={<I18n trans={`general:menu.${prop.name}`}/>}
                            disableTypography={true}
                            className={cx({[itemText]: prop.icon !== undefined}, {[collapseItemText]: prop.icon === undefined})}
                        />
                    </NavLink>
                </ListItem>
            );
        });
    };

    render() {
        const {classes, logo, image, logoText, routes, bgColor, rtlActive, miniActive, sidebarMinimize} = this.props;
        const links = <List className={classes.list}>{this.createLinks(routes)}</List>;
        const logoNormal = classes.logoNormal;
        const logoMini = classes.logoMini;
        const logoClasses = classes.logo;
        const brand = (
            <div className={logoClasses}>
                <img src={logo} alt="MVNO | Orange dla Operatorów" className={classes.img}
                     style={this.props.miniActive && this.state.miniActive ? {marginLeft: 10} : null}/>
                {this.props.miniActive && this.state.miniActive ? '' : <span className={classes.logoTitle}>MVNO</span>}
            </div>
        );
        const drawerPaper =
            classes.drawerPaper +
            ' ' +
            cx({
                [classes.drawerPaperMini]: this.props.miniActive && this.state.miniActive,
                [classes.drawerPaperRTL]: rtlActive,
            });
        const sidebarWrapper =
            classes.sidebarWrapper +
            ' ' +
            cx({
                [classes.drawerPaperMini]: this.props.miniActive && this.state.miniActive,
                [classes.sidebarWrapperWithPerfectScrollbar]: navigator.platform.indexOf('Win') > -1,
            });
        const userWrapperClass = classes.user + ' ' + cx({[classes.whiteAfter]: bgColor === 'white'});
        const itemText =
            classes.itemText +
            ' ' +
            cx({
                [classes.itemTextMini]: this.props.miniActive && this.state.miniActive,
                [classes.itemTextMiniRTL]: false,
                [classes.itemTextRTL]: false,
            });
        const user = null;
        return (
            <div ref="mainPanel">
                <Hidden mdUp implementation="css">
                    <Drawer
                        variant="temporary"
                        anchor={rtlActive ? 'left' : 'right'}
                        open={this.props.open}
                        classes={{
                            paper: drawerPaper + ' ' + classes[bgColor + 'Background'],
                        }}
                        onClose={this.props.handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                    >
                        {brand}
                        <SidebarWrapper className={sidebarWrapper} user={user} links={links}/>
                        <div style={{zIndex: 99999, position: 'absolute', left: 30, bottom: 10, overflowX: 'hidden'}}>
                            {miniActive ? (
                                <Button className={classes.sidebarMiniIcon} justIcon onClick={sidebarMinimize}>
                                    <Download style={{transform: 'rotate(-90deg)'}}/>
                                </Button>
                            ) : (
                                <Button className={classes.sidebarMiniIcon} justIcon onClick={sidebarMinimize}>
                                    <Download style={{transform: 'rotate(90deg)'}}/>
                                </Button>
                            )}
                        </div>
                    </Drawer>
                </Hidden>
                <Hidden smDown implementation="css">
                    <Drawer
                        onMouseOver={() => this.setState({miniActive: false})}
                        onMouseOut={() => this.setState({miniActive: true})}
                        anchor={rtlActive ? 'right' : 'left'}
                        variant="permanent"
                        open
                        classes={{
                            paper: drawerPaper + ' ' + classes[bgColor + 'Background'],
                        }}
                    >
                        {brand}
                        <SidebarWrapper className={sidebarWrapper} user={user} links={links}/>
                        <div style={{width: '100%', height: 70, padding: 10, position: 'relative'}}>
                            <div style={{
                                zIndex: 99999,
                                position: 'absolute',
                                left: 30,
                                bottom: 10,
                                overflowX: 'hidden'
                            }}>
                                {/*onClick={props.sidebarMinimize}*/}
                                {miniActive ? (
                                    <Button className={classes.sidebarMiniIcon} justIcon onClick={sidebarMinimize}>
                                        <Download style={{transform: 'rotate(-90deg)'}}/>
                                    </Button>
                                ) : (
                                    <Button className={classes.sidebarMiniIcon} justIcon onClick={sidebarMinimize}>
                                        <Download style={{transform: 'rotate(90deg)'}}/>
                                    </Button>
                                )}
                            </div>
                        </div>
                    </Drawer>
                </Hidden>
            </div>
        );
    }
}

Sidebar.defaultProps = {
    bgColor: 'blue',
};

Sidebar.propTypes = {
    classes: PropTypes.object.isRequired,
    bgColor: PropTypes.oneOf(['white', 'black', 'blue']),
    rtlActive: PropTypes.bool,
    color: PropTypes.oneOf(['orange']),
    logo: PropTypes.string,
    logoText: PropTypes.string,
    image: PropTypes.string,
    routes: PropTypes.arrayOf(PropTypes.object),
    sidebarMinimize: PropTypes.func
};

export default withStyles(OplSidebarStyle)(Sidebar);
